import { Component, OnInit } from '@angular/core';
import {NgbModal, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-filter-user-dialog',
  templateUrl: './filter-user-dialog.component.html',
  styleUrls: ['./filter-user-dialog.component.scss']
})
export class FilterUserDialogComponent implements OnInit {

  criterioBusqueda:string="";
  tipoBusqueda="1";
  estatus;

  constructor(
    public activeModal: NgbActiveModal
  ) { 
    
  }

  ngOnInit() {
  }

  cancelSearch(){

    this.activeModal.close('close'); 


  }
  filtrar(){
    if(this.tipoBusqueda == '11' || this.tipoBusqueda == '12') {
      this.filtrarUsuarios();
    } else {
      if(this.criterioBusqueda==""){

        // console.log("debe colocar un criterio de busqueda"); 
       
       }else{
        this.filtrarUsuarios();
      }
    }
  }

  filtrarUsuarios() {
    if (this.tipoBusqueda == '11') {
      this.estatus = 1;
      this.tipoBusqueda = '3';
    } else if (this.tipoBusqueda == '12') {
      this.estatus = 0;
      this.tipoBusqueda = '3';
    }

    let data={
      criterio:this.criterioBusqueda,
      tipo:this.tipoBusqueda,
      estatus: this.estatus
    }
    this.activeModal.close(data); 
  }

  // h(x) {
  //   console.log(x);
  // }

}



// WEBPACK FOOTER //
// ./src/app/components/filter-user-dialog/filter-user-dialog.component.ts